import { clientTransactionsDirectDebitsRoute } from './ClientTransactionsDirectDebits/route';
import { clientTransactionsFutureRoute } from './ClientTransactionsFuturePage/route';
import { clientTransactionsHistoryRoute } from './ClientTransactionsHistoryPage/route';
import { clientTransactionsSiposRoute } from './ClientTransactionsSiposPage/route';
import { clientTransactionsStandingOrdersRoute } from './ClientTransactionsStandingOrdersPage/route';
import { clientTransactionsRoute } from './route';

export const clientTransactionsRoutes = clientTransactionsRoute.addChildren([
	clientTransactionsHistoryRoute,
	clientTransactionsStandingOrdersRoute,
	clientTransactionsFutureRoute,
	clientTransactionsSiposRoute,
	clientTransactionsDirectDebitsRoute,
]);
